import styled from 'styled-components/macro';
import { Box, Flex, Button } from 'components/ui';
import { Link } from 'react-router-dom';
import { remixEnabled } from 'utils/config';
import RemixStudioPreview from 'img/remix-studio-preview.svg';
import RemixStudioBg from 'img/remix-studio-section-bg.png';
import SectionWrapper from 'components/ui/SectionWrapper';
import SectionTitle from 'components/ui/SectionTitle';

const Headline = styled(Box)`
  z-index: 1;

  h1 {
    text-align: left;
  }

  a {
    text-decoration: none;
  }
`;

const RemixStudioSection = () => {
  return (
    <SectionWrapper
      height="396px"
      backgroundImage={`url(${RemixStudioBg})`}
      backgroundPosition="center"
      backgroundSize="cover"
    >
      <Headline p={['40px 16px', '40px']}>
        <SectionTitle fontWeight={700}>Remix </SectionTitle>
        <SectionTitle fontWeight={400}>Studio</SectionTitle>
        <Box
          mt={2}
          mb={4}
          width="100%"
          maxWidth="440px"
          fontSize="16px"
          lineHeight={1.375}
          fontWeight={400}
        >
          Try Remix Studio today and create brand new remixes using your own Futura NFTs. With
          EulerBeats' cutting-edge technology, the possibilities are endless.
        </Box>
        <Flex flexDirection={['column', 'row']}>
          <Link to="/futura/remix">
            <Button
              mb={2}
              color="white"
              bg="black"
              border="1px solid white"
              disabled={!remixEnabled}
            >
              Try Remix Studio
            </Button>
          </Link>
        </Flex>
      </Headline>
      <Box width="50%" zIndex={5} display={['none', 'block']}>
        <Box maxWidth="512px" margin="0 auto">
          <img src={RemixStudioPreview} alt="Remix Studio" width="100%" />
        </Box>
      </Box>
    </SectionWrapper>
  );
};

export default RemixStudioSection;
